import { render } from "./Switch.htm?vue&type=template&id=70bf3db1&scoped=true"
import script from "./Switch.js?vue&type=script&lang=js"
export * from "./Switch.js?vue&type=script&lang=js"

import "./Switch.scss?vue&type=style&index=0&id=70bf3db1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bf3db1"]])

export default __exports__